var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "navbar-positioning" },
    [
      _c(
        "ul",
        {
          ref: "items",
          staticClass: "items",
          style: _vm.styleOverrides,
          attrs: { tabindex: "-1" },
        },
        _vm._l(_vm.allLinks, function (link, index) {
          return _c(
            "NavbarLink",
            {
              key: index,
              ref: "navLinks",
              refInFor: true,
              attrs: { title: link.title, link: link.link },
            },
            [
              _c("KIcon", {
                attrs: {
                  icon: link.icon,
                  color: _vm.themeConfig.appBar.textColor,
                },
              }),
            ],
            1
          )
        }),
        1
      ),
      _vm.overflowMenuLinks && _vm.overflowMenuLinks.length > 0
        ? _c("KIconButton", {
            staticClass: "kiconbutton-style",
            attrs: {
              tooltip: _vm.coreString("moreOptions"),
              tooltipPosition: "top",
              ariaLabel: _vm.coreString("moreOptions"),
              icon: "optionsHorizontal",
              appearance: "flat-button",
              color: _vm.themeConfig.appBar.textColor,
              primary: false,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "menu",
                  fn: function () {
                    return [
                      _c("KDropdownMenu", {
                        attrs: {
                          primary: false,
                          disabled: false,
                          hasIcons: true,
                          options: _vm.overflowMenuLinks,
                        },
                        on: { select: _vm.handleSelect },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              843128583
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }